import React from 'react'

export default function SkelotonEffect() {
  return (
    <>
      <div className="container">
        <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 skeleton_section'>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className="card">
              <div className="card-img skeleton">

              </div>
              <div className="card-body">
                <h2 className="card-title skeleton">

                </h2>
                <p className="card-intro skeleton">

                </p>
              </div>
            </div>
          </div>
          
        </div>

      </div>
    </>
  )
}
